import { alertReducer, initialState } from './AlertsReducer';
import React, { createContext, useReducer, Dispatch, ReactNode, useContext } from 'react';
import { AlertsActionTypes, IAlertsState } from './types';
import { ALERT_RESPONSES } from '../../utils/constants';
interface AlertsProviderProps {
  children: ReactNode;
}

interface AlertsContextProps {
  state: IAlertsState;
  dispatch: Dispatch<any>;
}

interface UseAlertsValue {
  state: IAlertsState;
  dispatch: Dispatch<any>;
  showAlert: (message: string, type: ALERT_RESPONSES) => void;
  hideAlert: () => void;
}

export const useAlert = (): UseAlertsValue => {
  const context = useContext(AlertsContext);

  if (context === undefined) {
    throw new Error('useAlert must be used within a AlertsProvider');
  }

  const showAlert = (message: string, type: ALERT_RESPONSES) => {
    context.dispatch({
      type: AlertsActionTypes.SHOW_ALERT,
      payload: { message, type },
    });
  };

  const hideAlert = () => {
    context.dispatch({
      type: AlertsActionTypes.HIDE_ALERT,
    });
  };

  return {
    state: context.state,
    dispatch: context.dispatch,
    showAlert,
    hideAlert,
  };
};

export const AlertsContext = createContext<AlertsContextProps>({
  state: initialState,
  dispatch: () => undefined,
});

export const AlertsProvider: React.FC<AlertsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(alertReducer, initialState);

  return (
    <AlertsContext.Provider value={{ state, dispatch }}>
      {children}
    </AlertsContext.Provider>
  );
};

